import GoalDetailsView from "./GoalDetailsView"
export default GoalDetailsView
